
const digest = '523c2347932ee8cd70a4298f4d5242db65284778404b8a8c0ca3cb0fac2fcb12';
const classes = {"image":"_image_n3b12_1"};
const css = `._image_n3b12_1 {
  max-width: 100%;
  margin-bottom: 50px;
  object-fit: contain;
  width: 100%;
  aspect-ratio: 2/1.5;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  